module.exports = __webpack_public_path__ + "img/icon_hospital.746cf475.png";